import { useEffect, useState } from "react";

// True when the viewport is phone-ish, so the setup screens switch from the
// multi-column desktop layout to a single-column tabbed layout. A real media
// breakpoint (not a device toggle), so it also caps couch play at 2 humans.
export function useNarrow(breakpoint = 900): boolean {
  const [narrow, setNarrow] = useState(() => (typeof window !== "undefined" ? window.innerWidth < breakpoint : false));
  useEffect(() => {
    function onResize() {
      setNarrow(window.innerWidth < breakpoint);
    }
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return narrow;
}
